const initialState = {
  onboarding: {
    completedSteps: [],
    currentStep: '',
    isOnboardingStarted: false,
    seasonModalsVisible: false,
    eventModalsVisible: false,
    disposableModalsVisible: false,
    achievementsModalsVisible: false,
    mainInfoModalsVisible: false,
    marchModalsVisible: false,
    premiumModalsVisible: false,
  },
};

const reducers = {
  // Инициализация массива данных с пройденными шагами
  setCompletedStepsData(state, { payload: data }) {
    state.onboarding.completedSteps = data || [];
  },

  // Установка флага isOnboardingStarted
  setOnboardingStarted(state, { payload: value }) {
    state.onboarding.isOnboardingStarted = value;
  },

  // Добавляем текущий шаг в завершенные
  addCurrentStepToCompleted(state) {
    state.onboarding.completedSteps.push(state.onboarding.currentStep);
  },

  // Установка активного/текущего шага
  setCurrentOnboardingStep(state, { payload: value }) {
    state.onboarding.currentStep = value;
  },

  // Сброс данных онбординга к дефолтным
  resetOnboardingState(state) {
    state.onboarding.currentStep = '';
    state.onboarding.isOnboardingStarted = false;
  },

  // Установка флага seasonModalsVisible, eventModalsVisible, disposableModalsVisible, achievementsModalsVisible и mainInfoModalsVisible
  // Порядок изменения значения учитывается
  setUserModalsVisibility(state, { payload: value }) {
    state.onboarding.seasonModalsVisible = value;
    state.onboarding.eventModalsVisible = value;
    state.onboarding.disposableModalsVisible = value;
    state.onboarding.achievementsModalsVisible = value;
    state.onboarding.mainInfoModalsVisible = value;
    state.onboarding.premiumModalsVisible = value;
  },

  // Установка флага marchModalsVisible
  setMarchModalsVisibility(state, { payload: value }) {
    state.onboarding.marchModalsVisible = value;
  },
};

const onboardingSegment = {
  initialState,
  reducers,
};

export default onboardingSegment;
